import { Injectable } from '@angular/core';

import { HttpClientService } from '../common/http-client.service';

@Injectable({
  providedIn: 'root'
})
export class ActivityMatterRatesService {
  url: string = 'activity_matter_rates';

  constructor(private httpClient: HttpClientService) {}

  getSearchOptions(params: any = {}): Promise<any> {
    params.get_search_options = true;
    return this.httpClient.get(`${this.url}.json`, params);
  }

  index(search_options: any): Promise<any> {
    return this.httpClient.get(`${this.url}.json`, search_options)
  }

  delete(id: number): Promise<any> {
    console.log("id from activity matter rates service:", id)
    return this.httpClient.delete(`${this.url}/${id}.json`);
  }

  show(id: number): Promise<any> {
    return this.httpClient.get(`${this.url}/${id}.json`);
  }

  update(id: number, params: any): Promise<any> {
    return this.httpClient.put(`${this.url}/${id}.json`, params);
  }
}
